// src/modules/app-views/omnichannel/pages/Init/modals/OmnichannelParametersModal/tabs/CleanupTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback } from 'react';
import { Button, Card, Flex, Modal, Typography } from 'antd';
import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import omnichannelService from 'modules/app-views/omnichannel/service';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CleanupTab = ({ loading, setLoading }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [cleaning, setCleaning] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleCleanup = useCallback(() => {
    Modal.confirm({
      title: translateX('confirm_cleanup_orphans'),
      icon: <ExclamationCircleFilled />,
      content: translateX('confirm_cleanup_orphans_description'),
      okText: translateX('yes'),
      cancelText: translateX('no'),
      okButtonProps: { danger: true },
      onOk: async () => {
        setCleaning(true);
        setLoading(true);
        try {
          const result = await omnichannelService.cleanupOrphans();
          const count = result?.orphanedCount || 0;
          if (count > 0) {
            appService.message({
              flag: 's',
              text: translateX('orphan_cleanup_success', { count }),
            });
          } else {
            appService.message({
              flag: 'i',
              text: translateX('no_orphan_messages_found'),
            });
          }
          // Refresh conversation list to remove orphans from UI
          window.dispatchEvent(new CustomEvent('omnichannel:conversations-refresh'));
        } catch (error) {
          console.error('[CleanupTab] cleanup error:', error);
          appService.message({ flag: 'e', text: translateX('error_cleaning_orphans') });
        } finally {
          setCleaning(false);
          setLoading(false);
        }
      },
    });
  }, [setLoading]);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex vertical gap={16}>
      <Card
        title={translateX('clean_orphan_messages')}
        size="small"
      >
        <Flex vertical align="center" gap={16}>
          <Typography.Text type="secondary" style={{ textAlign: 'center' }}>
            {translateX('clean_orphan_messages_description')}
          </Typography.Text>

          <Button
            danger
            type="primary"
            icon={<DeleteOutlined />}
            onClick={handleCleanup}
            loading={cleaning}
            disabled={loading}
          >
            {translateX('clean_now')}
          </Button>
        </Flex>
      </Card>
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CleanupTab;
